// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38ccJ","largestCol":"styles_largestCol__PGYb3","smallestCol":"styles_smallestCol__2tdtX"};